module.exports = __webpack_public_path__ + "static/media/ic_status_production_outlined.ba4efc06.svg";